var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadContent"},[_c('svg-icon',{staticClass:"svgicon",attrs:{"name":"Warning-face"}}),_c('span',[_vm._v(_vm._s(_vm.$t('topUpAdminAddCardInfo')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }